export enum KEY_CODE {
    DOWN_ARROW = 40,
    RIGHT_ARROW = 39,
    UP_ARROW = 38,
    LEFT_ARROW = 37,
    TAB = 9,
    ENTER = 13,
    ESC = 27
}
